import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {TreatmentConverter} from '../../../api/converter/treatment.converter';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {TreatmentModel} from '../../../api/model/treatment.model';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';

@Injectable({providedIn: 'root'})
export class TreatmentDataService extends AbstractDataServiceV2<TreatmentModel, TreatmentConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: TreatmentConverter) {
        super('Treatment', http, httpUrlGenerator, logger, config, converter);
    }
}
